<template>
    <b-modal size="xl" style="max-width: 80%!important;" ref="ipoteka-payment-transaction-add-edit-modal" :title="$t('finance.ipoteka.paymentTransaction.titleNew')"
             @ok="okBtn"
             :no-close-on-backdrop="true"
             :no-close-on-esc="true">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <loading2 style="" v-if="processing"></loading2>

                    <!--<div class="card-header">-->
                        <!--<div class="row">-->
                            <!--<div class="col">-->
                                <!--<h4 class="card-title float-left" v-if="paymentTransaction.id!=null">{{$t('finance.ipoteka.paymentTransaction.titleEdit')}}</h4>-->
                                <!--<h4 class="card-title float-left" v-else>{{$t('finance.ipoteka.paymentTransaction.titleNew')}}</h4>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <div class="card-body">
                        <div class="row p-2">
                            <div class="col-12 col-md-6 card card-body">
                                <div class="form-group">
                                    <center><span class="text-center font-weight-bold">Дебетор</span></center>
                                    <hr color="black"/>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.paymentTransaction.debetName')}}<span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="paymentTransaction.debetName"
                                           :placeholder="$t('finance.ipoteka.paymentTransaction.debetName')"
                                           :disabled="true"
                                           :class="{invalid : $v.paymentTransaction.debetName.$error}"/>
                                    <div class="red" v-if="$v.paymentTransaction.debetName.$error">
                                        {{$t('finance.ipoteka.paymentTransaction.debetName')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.paymentTransaction.debetINN')}}<span class="red">*</span></label>
                                    <numeric-input2 v-model="paymentTransaction.debetINN" :formatType="'String'" :maxlength="20" :disabled="true" :placeholder="$t('finance.ipoteka.paymentTransaction.debetINN')">
                                    </numeric-input2>
                                    <div class="red" v-if="$v.paymentTransaction.debetINN.$error">
                                        {{$t('finance.ipoteka.paymentTransaction.debetINN')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.paymentTransaction.debetMFO')}}<span class="red">*</span></label>
                                    <numeric-input2 v-model="paymentTransaction.debetMFO" :formatType="'String'" :maxlength="5" :disabled="true" :placeholder="$t('finance.ipoteka.paymentTransaction.debetMFO')">
                                    </numeric-input2>
                                    <div class="red" v-if="!$v.paymentTransaction.debetMFO.minLength">
                                        Узунлиги 4 тадан кам булмаслиги керак
                                    </div>
                                    <div class="red" v-if="$v.paymentTransaction.debetMFO.$error">
                                        {{$t('finance.ipoteka.paymentTransaction.debetMFO')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.paymentTransaction.debetAccount')}}<span class="red">*</span></label>
                                    <numeric-input2 v-model="paymentTransaction.debetAccount" :formatType="'String'" :maxlength="20" :disabled="true" :placeholder="$t('finance.ipoteka.paymentTransaction.debetAccount')">
                                    </numeric-input2>
                                    <div class="red" v-if="$v.paymentTransaction.debetAccount.$error">
                                        {{$t('finance.ipoteka.paymentTransaction.debetAccount')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <center><span class="text-center font-weight-bold">ТУЛОВ СУММА ВА МАКСАДИ</span></center>
                                    <hr color="black"/>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.payAmount')}}<span class="red">*</span></label>
                                    <numeric-input :precision="2" v-model="paymentTransaction.amountSum" :maxlength="8" :class="{invalid : $v.paymentTransaction.amountSum.$error}">
                                    </numeric-input>
                                    <div class="red" v-if="$v.paymentTransaction.amountSum.$error">
                                        {{$t('finance.ipoteka.field.payAmount')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.creditPurpose')}}<span class="red">*</span></label>
                                    <textarea
                                            cols="30" rows="3"
                                            class="form-control"
                                            v-model="paymentTransaction.purpose"
                                            :class="{invalid : $v.paymentTransaction.purpose.$error}"
                                    ></textarea>
                                    <div class="red" v-if="!$v.paymentTransaction.purpose.minLength">
                                        Узунлиги 20 тадан кам булмаслиги керак
                                    </div>
                                    <div class="red" v-if="$v.paymentTransaction.purpose.$error">
                                        {{$t('finance.ipoteka.field.creditPurpose')}}
                                    </div>

                                </div>
                                <div class="form-group" v-if="paymentTransaction.expensePayDate!=null">
                                    <label>{{$t('finance.ipoteka.fixedExpenses.fixedExpensePaymentDate')}}: </label>
                                    <span>{{paymentTransaction.expensePayDate}}</span>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 card card-body">
                                <div class="form-group">
                                    <center><span class="text-center font-weight-bold">Кредитор</span></center>
                                    <hr color="black"/>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.paymentTransaction.creditName')}}<span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="paymentTransaction.creditName"
                                           :placeholder="$t('finance.ipoteka.paymentTransaction.creditName')"
                                           :class="{invalid : $v.paymentTransaction.creditName.$error}"/>
                                    <div class="red" v-if="$v.paymentTransaction.creditName.$error">
                                        {{$t('finance.ipoteka.paymentTransaction.creditName')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.paymentTransaction.creditINN')}}<span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="paymentTransaction.creditINN"
                                            maxlength="12"
                                           @keypress="validate"
                                           :placeholder="$t('finance.ipoteka.paymentTransaction.creditINN')"
                                           :class="{invalid : $v.paymentTransaction.creditINN.$error}"/>
                                    <div class="red" v-if="$v.paymentTransaction.creditINN.$error">
                                        {{$t('finance.ipoteka.paymentTransaction.creditINN')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.paymentTransaction.creditAccount')}}<span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="paymentTransaction.creditAccount"
                                           maxlength="20"
                                           @keypress="validate"
                                           :placeholder="$t('finance.ipoteka.paymentTransaction.creditAccount')"
                                           :class="{invalid : $v.paymentTransaction.creditAccount.$error}"/>
                                    <div class="red" v-if="$v.paymentTransaction.creditAccount.$error">
                                        {{$t('finance.ipoteka.paymentTransaction.creditAccount')}}
                                    </div>
                                    <div class="red" v-if="!$v.paymentTransaction.creditAccount.minLength">
                                        Узунлиги 20 тадан кам булмаслиги керак
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.paymentTransaction.creditMFO')}}<span class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="paymentTransaction.creditMFO"
                                           maxlength="5"
                                           :placeholder="$t('finance.ipoteka.paymentTransaction.creditMFO')"
                                           @input="onChangeMFO"
                                           @keypress="validate"
                                           :class="{invalid : $v.paymentTransaction.creditMFO.$error}"/>
                                    <div class="red" v-if="!$v.paymentTransaction.creditMFO.minLength">
                                        Узунлиги 5 тадан кам булмаслиги керак
                                    </div>
                                    <div class="red" v-if="$v.paymentTransaction.creditMFO.$error">
                                        {{$t('finance.ipoteka.paymentTransaction.creditMFO')}}
                                    </div>
                                </div>
                                <div class="form-group">
                                    <span class="font-weight-bold x3 text-success">{{paymentTransaction.creditBankName}}</span>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.operationType')}}: <span class="red">*</span> </label>
                                    <select class="form-control" v-model="paymentTransaction.operationType" @change="changeOperationType" :class="{invalid : $v.paymentTransaction.operationType.$error}">
                                        <option value="1">Обычная проводка</option>
                                        <!--<option value="2">Казначейский платеж</option>-->
                                    </select>
                                    <div class="red" v-if="$v.paymentTransaction.operationType.$error">
                                        {{$t('finance.ipoteka.field.operationType')}}
                                    </div>
                                </div>

                                <div v-show="paymentTransaction.operationType==2">
                                <div class="form-group">
                                    <center><span class="text-center">Буджет</span></center>
                                    <hr color="black"/>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.nameBudget')}}<span
                                            class="red">*</span></label>
                                    <input type="text" class="form-control" v-model="paymentTransaction.nameBudget"
                                           :placeholder="$t('finance.ipoteka.field.nameBudget')"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.codeBudget')}}<span
                                            class="red">*</span></label>
                                    <numeric-input2 v-model="paymentTransaction.codeBudget" :formatType="'String'"
                                                    :maxlength="2"
                                                    :placeholder="$t('finance.ipoteka.field.codeBudget')">
                                    </numeric-input2>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.accountBudgetIncome')}}<span
                                            class="red">*</span></label>
                                    <numeric-input2 v-model="paymentTransaction.accountBudgetIncome"
                                                    :formatType="'String'" :maxlength="2"
                                                    :placeholder="$t('finance.ipoteka.field.accountBudgetIncome')">
                                    </numeric-input2>
                                </div>
                                <div class="form-group">
                                    <label>{{$t('finance.ipoteka.field.innBudget')}}<span
                                            class="red">*</span></label>
                                    <numeric-input2 v-model="paymentTransaction.innBudget" :formatType="'String'"
                                                    :maxlength="20"
                                                    :placeholder="$t('finance.ipoteka.field.innBudget')">
                                    </numeric-input2>
                                </div>
                                </div>

                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-6">
                            <div class="card mt-3">
                                <div class="card-header bg-success">
                                    <span style="color: white">Холат</span>
                                </div>
                                <div class="card-body">
                                    <ul class="list-group list-group-flush">
                                        <li class="list-group-item text-center">
                                            <div class="badge badge-secondary" v-if="paymentTransaction.state==='DRAFT'">
                                                {{$t("common.draft")}}
                                            </div>
                                            <div class="badge badge-primary" v-else-if="paymentTransaction.state==='WAIT'">
                                                {{$t("finance.uzCard.transaction.status.wait")}}
                                            </div>
                                            <div class="badge badge-success" v-else-if="paymentTransaction.state==='DONE'">
                                                <span>{{$t("finance.uzCard.transaction.status.paid")}}</span>
                                            </div>
                                            <div class="badge badge-danger" v-else>{{$t("finance.uzCard.transaction.status.unknown")}}</div>
                                            <br/>
                                            <div class="badge badge-info" v-if="paymentTransaction.finishedDate">
                                                {{$t('finance.field.date')}} {{new Date(paymentTransaction.finishedDate) | dateFormat('DD/MM/YYYY HH:mm')}}
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div class="row" v-if="paymentTransaction.state==='DRAFT' || paymentTransaction.state==='UNKNOWN'">
                            <div class="col-sm-5"></div>
                            <div class="col-sm-7">
                                <BaseTimerView @input="finishedTime" v-if="!processing"></BaseTimerView>
                                <!--<h4 class="card-title float-left" v-if="paymentTransaction.id!=null">{{$t('finance.ipoteka.paymentTransaction.titleEdit')}}</h4>-->
                                <!--<h4 class="card-title float-left" v-else>{{$t('finance.ipoteka.paymentTransaction.titleNew')}}</h4>-->
                            </div>
                        </div>
                        <div class="row mt-5" v-if="paymentTransaction.state==='DRAFT' || paymentTransaction.state==='UNKNOWN'">
                            <div class="col-12 text-center" v-if="!processing">
                                <!--<button class="all-btn delete-btn" @click="cancel" v-if="!hasModal" :disabled="processing">-->
                                    <!--{{$t("action.cancel")}}-->
                                <!--</button>-->
                                <button class="all-btn add-btn ml-3" @click="save('DRAFT')"
                                        :disabled="processing" v-if="hasPermission('IPOTEKA_BANK_PAYMENT_TRANSACTIONS_ADD') && paymentTransaction.state==='UNKNOWN'">
                                    {{$t("action.draft")}}
                                </button>
                                <button class="all-btn add-btn ml-3" @click="save('DONE')"
                                        :disabled="processing" v-if="hasPermission('IPOTEKA_BANK_PAYMENT_TRANSACTIONS_EDIT')">
                                    {{$t("action.pay")}}
                                </button>
                            </div>
                        </div>
                        <loading2 style="" v-if="processing"></loading2>
                        <BankApiLoginInputView @input="onChangeLoginForm" :smsField="true"></BankApiLoginInputView>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </b-modal>
</template>

<script>
    import {required,minValue,minLength, integer} from 'vuelidate/lib/validators';
    // import {EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
    import initFilterModel from '@/shared/filter';
    // import DatePicker from 'vuejs-datepicker';
    import {formatDate, parseDate} from '@/shared/utils';
    // import CustomDatePicker from '@/views/common/CustomDatePicker'
    import NumericInput2 from '@/views/common/NumericInput2'
    // import {BANK_API} from '@/axios';
    import BankApiLoginInputView from "@/views/common/BankApiLoginInputView";
    import BaseTimerView from "@/views/common/BaseTimerView";
    import Loading2 from '@/views/Loading2';
    import bModal from 'bootstrap-vue/es/components/modal/modal'


    export default {
        name: "IpotekaPaymentTransactionAddEditView",
        components: {
            // CustomDatePicker,
            NumericInput2,
            BankApiLoginInputView,
            BaseTimerView,
            Loading2,
            bModal
        },
        data() {
            return {
                parseDate: parseDate,
                formatDate: formatDate,
                processing: false,
                loading: {
                    isDocQrLoading: false,
                },
                ownerFilter: initFilterModel(),
                editIndex: null,
                loadingExcelCalc: false,
                paymentTransaction: {
                    id: null,
                    debetName: 'ELEKTRON BAHOLASH MCHJ',
                    debetINN: '303178701',
                    debetMFO: '00580',
                    debetAccount: '20208000700424417001',

                    state: 'DRAFT',
                    operationType: 1,
                    payDate: null,
                    amountSum: null,
                    creditName: null,
                    creditINN: null,
                    creditAccount: null,
                    creditMFO: null,
                    creditBankName: null,
                    documentNumber: null,
                    purpose: null,
                    expenseType: null,

                    codeBudget: null,
                    nameBudget: null,
                    accountBudgetIncome: null,
                    innBudget: null,
                    fixedExpenseId: null,
                    expensePayDate: null,
                },
                model: {
                    disabledDates:{}
                },
                provinces: [],
                itemFilter: initFilterModel(),
                results: null,
                readyToTransfer: false
            }
        },
        validations() {
            return {
                paymentTransaction: {
                    operationType: {
                        required: required
                    },
                    debetName: {
                        required: required
                    },
                    debetINN: {
                        required: required,
                        integer: integer
                    },
                    debetMFO: {
                        required: required,
                        minLength: minLength(4),
                        integer: integer
                    },
                    debetAccount: {
                        required: required,
                        integer: integer
                    },
                    amountSum: {
                        required: required,
                        minValue: minValue(1)
                    },
                    creditName: {
                        required: required
                    },
                    creditINN: {
                        required: required,
                        integer: integer
                    },
                    creditAccount: {
                        required: required,
                        minLength: minLength(20),
                        integer: integer
                    },
                    creditMFO: {
                        required: required,
                        minLength: minLength(5),
                        integer: integer
                    },
                    // documentNumber: {
                    //     required: required,
                    //     minLength: minLength(1)
                    // },
                    purpose: {
                        required: required,
                        minLength: minLength(20)
                    },

                }
            }
        },
        methods: {
            init() {
                const vm = this;
                const id = this.$route.params.id;

                if (id && id > 0) {
                    this.$http.get('/accountant/ipoteka-payment-transaction/view/' + id)
                        .then(res => {
                            console.log(res);
                            vm.paymentTransaction = res.data;
                            this.processing = false;
                        }, () => {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.fixedExpense.error'),
                                type: 'error'
                            });
                            this.processing = false;
                        })

                }
            },
            changeOperationType(){
                console.log(this.paymentTransaction.operationType);
            },
            saveToServer(state) {
                this.processing = true;
                this.paymentTransaction.state = state;
                this.$http.post('/accountant/ipoteka-payment-transaction/save', this.paymentTransaction)
                    .then(res => {
                        console.log(res);
                        if (res.data.status==="SUCCESS") {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.ipotekaPaymentTransaction.success') + '\n ' + res.data.message,
                                type: 'success'
                            });
                            this.back();
                        } else {
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.ipotekaPaymentTransaction.error') + '\n ' + res.data.message,
                                type: 'error'
                            });
                            this.back();
                        }
                        this.processing = false;
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.ipotekaPaymentTransaction.error'),
                            type: 'error'
                        });
                        this.back();
                        this.processing = false;
                    });

            },
            onChangeLoginForm(data) {
                if (data != null) {
                    this.paymentTransaction.login = data.login;
                    this.paymentTransaction.password = data.password;
                    this.paymentTransaction.smsCode = data.smsCode;
                    this.saveToServer('DONE');
                } else {
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: 'Login or password is empty',
                        type: 'error'
                    });
                }

            },
            save(state) {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                if (state === 'DONE') {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: this.$t('messages.common.reallyWant', {0: this.$t('finance.ipoteka.paymentTransaction.confirmMsg')}),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#dd3333',
                        confirmButtonText: 'Тулаш',
                        cancelButtonText: 'Бекор қилиш'
                    }).then((result) => {
                        if (result.value) {
                            this.$eventBus.$emit('showBankApiLoginInputView', null);
                        }
                    });
                } else {
                    this.$swal({
                        title: this.$t('messages.common.warning'),
                        text: this.$t('messages.common.reallyWant', {0: this.$t('finance.ipoteka.paymentTransaction.draftMsg')}),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#4321dd',
                        confirmButtonText: 'Черновик',
                        cancelButtonText: 'Бекор қилиш'
                    }).then((result) => {
                        if (result.value) {
                            this.saveToServer(state);
                        }
                    });
                }
            },
            back() {
                if (this.readyToTransfer) {
                    this.$refs['ipoteka-payment-transaction-add-edit-modal'].hide();
                    // this.$router.push('/finance/ipoteka/fixed-expenses-ready-transfer-list');
                } else {
                    this.$router.push('/finance/ipoteka/payment-list');
                }
            },
            okBtn(/*data*/) {
                console.log("777777");

            },
            validate(evt) {
                var theEvent = evt || window.event;

                // Handle paste
                if (theEvent.type === 'paste') {
                    key = event.clipboardData.getData('text/plain');
                } else {
                    // Handle key press
                    var key = theEvent.keyCode || theEvent.which;
                    key = String.fromCharCode(key);
                }
                var regex = /[0-9]|\./;
                if (!regex.test(key)) {
                    theEvent.returnValue = false;
                    if (theEvent.preventDefault) theEvent.preventDefault();
                }
            },
            finishedTime(data){
                console.log(data);
                this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: this.$t('messages.ipotekaPaymentTransaction.timeUp'),
                    type: 'warning'
                });
                this.$router.push('/finance/ipoteka/payment-list');
            },
            onChangeMFO() {
                this.processing = true;
                if (this.paymentTransaction.creditMFO.length >= 5) {
                    this.$http.get('/bank/mfo/' + this.paymentTransaction.creditMFO)
                        .then(res => {
                            console.log(res);
                            if (res.data.status === "SUCCESS") {
                                this.paymentTransaction.creditBankName = res.data.data.name;
                            } else {
                                this.paymentTransaction.creditBankName = null;
                                this.$swal({
                                    title: this.$t('messages.common.error'),
                                    text: this.$t('messages.common.errorOccurred') + '\n ' + res.data.message,
                                    type: 'error'
                                });
                            }
                            this.processing = false;
                        }, () => {
                            this.paymentTransaction.creditBankName = null;
                            this.$swal({
                                title: this.$t('messages.common.error'),
                                text: this.$t('messages.common.errorOccurred'),
                                type: 'error'
                            });
                            this.processing = false;
                        });
                } else {
                    this.paymentTransaction.creditBankName = null;
                }
            },

        },
        computed: {

        },
        created() {
           this.init();

            this.$eventBus.$on('showIpotekaPaymentTransactionAddEditView', (data) => {
                // console.log("showIpotekaPaymentTransactionAddEditView = ");
                // console.log(data);
                this.paymentTransaction.creditName = data.creditName;
                this.paymentTransaction.creditINN = data.creditINN;
                this.paymentTransaction.creditAccount = data.creditAccount;
                this.paymentTransaction.creditMFO = data.creditMFO;
                this.paymentTransaction.amountSum = data.payAmount;
                this.paymentTransaction.purpose = data.creditPurpose;
                this.paymentTransaction.operationType = data.operationType;
                this.paymentTransaction.state = data.state;
                this.paymentTransaction.fixedExpenseId = data.fixedExpenseId;
                this.paymentTransaction.expensePayDate = parseDate(data.payDate);


                if (data.readyToTransfer) {
                    this.readyToTransfer = data.readyToTransfer;
                    this.onChangeMFO();
                }
                setTimeout(() => {
                    this.paymentTransaction.creditBankName = null;
                    this.$refs['ipoteka-payment-transaction-add-edit-modal'].show();
                }, 100);

            });


        }
    }
</script>

<style scoped>
    .custom {
        font-family: "Trebuchet MS",Arial,Helvetica,sans-serif;
        border-collapse: collapse;
        width: 100%;
    }
    .custom td,.custom th{
        border: 1px solid #ddd;
        padding: 4px;
    }
    .custom tr:nth-child(even){
        background-color: #f2f2f2;
    }
    .custom tr:hover{
        opacity: 1;
        background-color: #dee2e6;
    }
    .custom thead tr th{
        border-bottom-width: 1px;
        padding-top: 4px;
        padding-bottom: 4px;
        text-align: center !important;
        color: #9A9A9A;
        text-transform: uppercase;
        font-size: 0.75rem;
        font-weight: 400;
    }
    .custom tr{
        font-size: 14px;
    }

</style>